define.alias("ember-power-select/components/power-select/before-options", "media/components/power-select/before-options");